import React from "react";
import { styled, Heading, PrimaryButton } from "@sourceful/shared-components";
import { SanityLearnMoreModalCTABlock } from "@sourceful/shared-types";
import Link from "next/link";
import { useRouter } from "next/router";

const Wrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "$block_s1",
  paddingBottom: "$block_s1",
});

const CtaWrapper = styled("div", { marginTop: "20px" });

interface LearnMoreModalCTAProps {
  cta: SanityLearnMoreModalCTABlock;
}

const LearnMoreModalCTA = ({ cta }: LearnMoreModalCTAProps) => {
  const router = useRouter();
  return (
    <Wrapper>
      <Heading level={6}>{cta.title}</Heading>
      <CtaWrapper>
        {cta.displayAs === "button" ? (
          <PrimaryButton onClick={() => router.push(cta.url)}>{cta.label}</PrimaryButton>
        ) : (
          <Link href={cta.url} legacyBehavior>
            {cta.label}
          </Link>
        )}
      </CtaWrapper>
    </Wrapper>
  );
};

export default LearnMoreModalCTA;
